import * as Period from '../../../../constants/Period';
var BANDY_PERIOD_MAP = {};
BANDY_PERIOD_MAP[3500] = Period.NOT_STARTED;
BANDY_PERIOD_MAP[3501] = Period.FIRST;
BANDY_PERIOD_MAP[3502] = Period.FIRST_BREAK;
BANDY_PERIOD_MAP[3503] = Period.SECOND;
BANDY_PERIOD_MAP[3504] = Period.FINISHED;
export default BANDY_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Bandy/PeriodMap.js